import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import moment from 'moment';
import { DirectoryEntryRemoteDto, StringOrgField } from 'src/generated/swagger';
import { SelectedSubscriberChanged } from './selected-subscriber.actions';

export interface SelectedSubscriberStateModel {
   selectedSubscriber: DirectoryEntryRemoteDto;
   selectionSetByBrickInstanceId: string;
   changedAt: moment.Moment;
}

@State<SelectedSubscriberStateModel>({
   name: 'selectedSubscriberState',
   defaults: {
      selectedSubscriber: null,
      selectionSetByBrickInstanceId: null,
      changedAt: moment(),
   },
})
@Injectable()
export class SelectedSubscriberState {
   constructor() {}

   @Selector([SelectedSubscriberState])
   public static selectionSetByBrickInstanceId(state: SelectedSubscriberStateModel): string {
      return state.selectionSetByBrickInstanceId;
   }

   @Selector([SelectedSubscriberState])
   public static selectedSubscriber(state: SelectedSubscriberStateModel): DirectoryEntryRemoteDto {
      return state.selectedSubscriber;
   }

   @Selector([SelectedSubscriberState.selectedSubscriber])
   public static selectedSubscriberId(selectedSubscriber: DirectoryEntryRemoteDto): number {
      return selectedSubscriber?.id;
   }

   @Selector([SelectedSubscriberState.selectedSubscriber])
   public static selectedSubscriberNumber(selectedSubscriber: DirectoryEntryRemoteDto): string {
      return selectedSubscriber?.orgnum;
   }

   @Selector([SelectedSubscriberState.selectedSubscriber])
   public static selectedSubscriberMobile(selectedSubscriber: DirectoryEntryRemoteDto): string {
      return selectedSubscriber?.fldMobile;
   }

   @Selector([SelectedSubscriberState.selectedSubscriber])
   public static selectedSubscriberEmail(selectedSubscriber: DirectoryEntryRemoteDto): StringOrgField {
      return selectedSubscriber?.email;
   }

   @Selector([SelectedSubscriberState.selectedSubscriber])
   public static selectedSubscriberName(selectedSubscriber: DirectoryEntryRemoteDto): string {
      return selectedSubscriber?.orgnam;
   }

   @Action(SelectedSubscriberChanged)
   public selectedSubscriberChanged(ctx: StateContext<SelectedSubscriberStateModel>, action: SelectedSubscriberChanged) {
      ctx.patchState({
         selectedSubscriber: action.selectedSubscriber,
         selectionSetByBrickInstanceId: action.brickInstanceId,
         changedAt: moment(),
      });
   }
}
